export const ROUTE_KEYS = {
  LOGIN: '/login',
  DASHBOARD: '',
  HOME: '/home',
  DEALS_AND_DISCOUNTS: '/deals-and-discounts',
  PUSH_NOTIFICATIONS: '/push-notifications',
  TRASH: '/trash',
  EMAILS: '/emails',
  EXPLORE: '/explore',
  PHOTO_CONTENT: 'upload-photo-content',
  VIDEO_CONTENT: 'upload-video-content',
  CREATE_POST: '/create-post',
  CREATE_DEAL: '/create-deal',
  CREATE_POST_DETAILS: 'details',
  CREATE_DEAL_DETAILS: 'details',
  CREATE_POST_TIMELINE: 'timeline',
  CREATE_DEAL_TIMELINE: 'timeline',
  CREATE_DEAL_SETTINGS: 'settings',
  EDIT_POST: '/posts/:postId/edit',
  EDIT_DEAL: '/deals/:dealId/edit',
  EDIT_POST_DETAILS: 'details',
  EDIT_DEAL_DETAILS: 'details',
  EDIT_POST_TIMELINE: 'timeline',
  EDIT_DEAL_TIMELINE: 'timeline',
  EDIT_DEAL_SETTINGS: 'settings'
};

export const STORAGE_KEYS = {
  AUTH_TOKEN: 'token',
  USER_ID: 'id',
  EMAIL: 'email',
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  ROLE: 'role',
  COKITCHEN: 'cokitchen',
  COKITCHEN_LIST: 'cokitchen_list',
  STAFF_NUMBER: 'staff_number',
  ACTIVE_COKITCHEN: 'active_cokitchen'
};

export const LEKKI_COKITCHEN = 'Cokitchen Lekki';
